<template>
  <div class="linexo-mini-header">
    <img class="linexo-mini-header__logo" src="/linexo-text-logo.png" alt="" />
    <div class="linexo-mini-header__title">
      {{ title }}
    </div>
  </div>
</template>
<script lang="ts" setup>
type MiniHeaderProps = {
  title: string
}
defineProps<MiniHeaderProps>()
</script>
<style lang="scss" scoped>
@import './mini-header.scss';
</style>
